import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RadarCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { RADAR_CHART } from "../../../../Data/Charts/ApexChart";

const RadarChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={RadarCharts} />
        <CardBody>
          <div id="radarchart">
            <Chart options={RADAR_CHART} series={RADAR_CHART.series} type="radar" height={300} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RadarChart;
